import React, { useState, useRef, useEffect } from 'react';
import Select from 'react-select';
import services from '../../services';
import { useParams } from 'react-router-dom';
const statusColors = [
    '#3b82f6',
    '#60a5fa',
    '#38bdf8',
    '#22d3ee',
    '#14b8a6',
    '#22c55e',
    '#a3e635',
    '#eab308',
    '#facc15',
    '#f59e0b',
    '#f97316',
    '#ef4444',
    '#ec4899',
    '#8b5cf6',
    '#a855f7',
    '#d1d5db',
    '#6b7280',
    '#374151',
    '#000000',
];
const AutomationStatusDropdown = ({
    idx, setSelectedCustomFieldByRow, customFieldOptionsByRow, selectedCustomFieldByRow,
    getDefaultColorByValue,
    customeFiedId,
    setCustomeFieldId,
    handleUpdateCell,
    propertyId,
    handleUpdatedCustomField,
    deleteCustomField,
    setCustomFieldOptionsByRow,
}) => {
    const [selectedStatusColor, setSelectedStatusColor] = useState(null);
    const [inputStatusEditValue, setInputStatusValue] = useState('');
    const [showOptionModal, setShowOptionModal] = useState(null);
    const [selecteStatusIndex, setSelecteStatusIndex] = useState(null);
    const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
    const [hoveredId, setHoveredId] = useState(null);
    const modalRef = useRef(null);
    const { id } = useParams();
    const [menuOpen, setMenuOpen] = useState(true);
    const StatusFields = customFieldOptionsByRow[idx] || [];
    const statusOptions = StatusFields.map(item => {
        const raw = item?._rawItem || {};
        const cf = raw.customField || {};
        const v = cf.value;

        const label =
            typeof v === "string"
                ? v
                : Array.isArray(v) && v[0]?.label
                    ? v[0].label
                    : typeof v === "object" && v?.label
                        ? v.label
                        : "";

        return {
            id: raw.id,            // ✅ used by edit modal
            value: raw.id,         // ✅ stable for react-select
            label,                 // ✅ string
            color: cf.color || "#6b7280",
            _rawItem: raw,
        };
    });



    const handleSelecteTag = (item, value, color, idx, flag) => {
        const propertyId = item?.id;

        const finalLabel = typeof value === 'object' ? value.label : value;

        const updatedValues = [
            {
                label: finalLabel,
                color,
                flag,
            },
        ];

        const newTagObj = {
            name: 'Tag',
            value: updatedValues,
        };

        if (customeFiedId) {
            handleUpdatedCustomField(item, updatedValues, color, 'Tag', idx);
        } else {
            handleUpdateCell(propertyId, updatedValues, color);
        }
    };
    const customStyles = {
        control: (base) => ({
            ...base,
            borderRadius: 8,
            boxShadow: '0 2px 8px #0001',
            border: '1px solid #ccc',
            minHeight: 38,
            fontSize: 14,
        }),
        option: (base, { isFocused }) => ({
            ...base,
            backgroundColor: isFocused ? '#f0f0f0' : '#fff',
            color: '#000',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        }),
        singleValue: (base) => ({
            ...base,
            display: 'flex',
            alignItems: 'center',
        }),
    };

    const formatOptionLabel = (data, { context }) => {
        // Normalize everything here
        const normalizeLabel = (label) => {
            if (typeof label === "string") return label;

            if (Array.isArray(label) && label.length > 0) {
                if (typeof label[0] === "string") return label[0];
                if (label[0]?.label) return label[0].label;
            }

            if (typeof label === "object" && label?.label) return label.label;

            return "";
        };


        const normalizedLabel = normalizeLabel(data.label);

        const normalizedColor = data?.color ?? "#6b7280";
        const normalizedId = data?.id ?? null;
        const normalizedIndex = data?.index ?? null;

        return (
            <div
                className="flex items-center justify-between w-full overflow-y-auto"
                onMouseEnter={() => setHoveredId(normalizedId)}
                onMouseLeave={() => setHoveredId(null)}
            >
                <span
                    className="inline-flex items-center rounded px-2 py-0.5 mr-1 text-[13px] font-medium"
                    style={{
                        backgroundColor: normalizedColor,
                        color: "white",
                    }}
                >
                    {normalizedLabel}
                </span>

                {context === "menu" && (
                    <div>
                        {hoveredId === normalizedId && (
                            <i
                                className="bi bi-sliders text-gray-500 hover:text-black text-sm ml-2"
                                onClick={async (e) => {
                                    e.stopPropagation();

                                    const rect = e.currentTarget.getBoundingClientRect();
                                    setModalPosition({
                                        top: rect.bottom + window.scrollY,
                                        left: rect.left + window.scrollX,
                                    });

                                    setShowOptionModal(normalizedId);
                                    setInputStatusValue(normalizedLabel);
                                    setCustomeFieldId(normalizedId);
                                    setSelecteStatusIndex(normalizedIndex);
                                    setSelectedStatusColor(normalizedColor);
                                }}
                            />
                        )}

                        <span
                            style={{
                                marginLeft: 6,
                                cursor: "grab",
                                fontSize: 14,
                            }}
                        >
                            ⋮⋮
                        </span>
                    </div>
                )}
            </div>
        );
    };


    useEffect(() => {
        const handleMouseDownOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setShowOptionModal(null);
            }
        };
        document.addEventListener('mousedown', handleMouseDownOutside);
        return () => {
            document.removeEventListener('mousedown', handleMouseDownOutside);
        };
    }, []);


    function filterObjectsByIds(idArray, objectArray) {
        return objectArray.filter(obj => idArray.includes(obj.id));
    }

    let formattedTagNew = [];

    if (Array.isArray(selectedCustomFieldByRow[idx])) {
        formattedTagNew = selectedCustomFieldByRow[idx]
            .map(obj => statusOptions.find(opt => opt.id === obj.id))
            .filter(Boolean);

    }



    return (
        <div className="relative z-[999]">

            <Select
                isMulti={true}
                options={statusOptions}
                styles={customStyles}
                placeholder="Select status"
                isClearable={true}
                hideSelectedOptions={false}
                closeMenuOnSelect={true}
                formatOptionLabel={formatOptionLabel}
                value={formattedTagNew}
                onChange={(selectedOptions) => {
                    if (!Array.isArray(selectedOptions)) {
                        setSelectedCustomFieldByRow(prev => ({ ...prev, [idx]: [] }));
                        return;
                    }

                    const cleanValues = selectedOptions.map(opt => ({
                        id: opt.id,
                        label: typeof opt.label === "object"
                            ? opt.label.label || ""
                            : Array.isArray(opt.label)
                                ? opt.label[0]?.label || ""
                                : opt.label,
                        color: opt.color
                    }));

                    // Update UI state
                    setSelectedCustomFieldByRow(prev => ({
                        ...prev,
                        [idx]: cleanValues
                    }));

                }}




                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();

                        handleUpdateCell(propertyId, e.target.value, 'grey', idx);
                    }
                }}
                menuPlacement="auto"
            // onMenuOpen={() => setMenuOpen(true)}
            />

            {statusOptions.map((status) => {
                const isModalOpen = showOptionModal === status.id;
                if (!isModalOpen) return null;
                return (
                    <div
                        key={status.id}
                        ref={modalRef}
                        className="fixed z-50 w-64 bg-white border border-gray-300 shadow-lg rounded p-4"
                        style={{
                            top: `${modalPosition.top}px`,
                            transform: "translate(0px, -50px)"
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex justify-between items-center mb-2">
                            <h3 className="text-sm font-semibold">Option details</h3>
                            <i
                                className="bi bi-trash text-black-500 cursor-pointer"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    deleteCustomField(customeFiedId, '', status);

                                }}
                            />
                        </div>

                        {/* <input
                            type="text"
                            className="w-full border border-black rounded px-2 py-1 text-sm mb-3"
                            value={inputStatusEditValue}
                            onChange={(e) => setInputStatusValue(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                        /> */}
                        <input
                            type="text"
                            placeholder="#tag"
                            value={inputStatusEditValue || ''}
                            className="w-full border border-gray-300 rounded-md px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                            onChange={(e) => {
                                e.stopPropagation();
                                const newValue = e.target.value;

                                setInputStatusValue(newValue);
                            }}

                            onKeyDown={(e) => {
                                e.stopPropagation();
                                if (e.key === 'Enter') {
                                    if (handleSelecteTag && item) {
                                        const selectedIndex =
                                            props.selectProps?.options?.findIndex(
                                                (option) => option.value === props.data.value,
                                            ) || 0;
                                        handleSelecteTag(item, editTagName.trim(), editTagColor, selectedIndex);
                                    }
                                }
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                            }}
                            onFocus={(e) => {
                                e.stopPropagation();
                                e.target.select();
                            }}
                            autoFocus
                        />

                        <div className="text-sm font-medium mb-2 text-black">Colors</div>

                        <div className="grid grid-cols-5 gap-2">
                            {statusColors.map((color) => (
                                <div
                                    key={color}
                                    className="w-6 h-6 rounded-full cursor-pointer relative flex items-center justify-center"
                                    style={{ backgroundColor: color }}
                                    onClick={() => setSelectedStatusColor(color)}
                                >
                                    {selectedStatusColor === color && (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="w-4 h-4 text-white"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth={3}
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                        </svg>
                                    )}
                                </div>
                            ))}
                        </div>
                        <div className="flex justify-end gap-2 mt-3">
                            <button
                                className="text-xs  text-white px-3 py-1.5 rounded-md hover:bg-blue-600 transition-colors"
                                onClick={() => {
                                    setShowOptionModal(null);

                                    handleUpdatedCustomField(propertyId, inputStatusEditValue, selectedStatusColor, selecteStatusIndex);
                                    setCustomFieldOptionsByRow(prev => ({
                                        ...prev,
                                        [idx]: prev[idx].map(opt =>
                                            opt._rawItem.id === customeFiedId
                                                ? {
                                                    ...opt,
                                                    _rawItem: {
                                                        ...opt._rawItem,
                                                        customField: {
                                                            ...opt._rawItem.customField,
                                                            value: {
                                                                label: inputStatusEditValue,
                                                                color: selectedStatusColor
                                                            },
                                                            color: selectedStatusColor
                                                        }
                                                    }
                                                }
                                                : opt
                                        )
                                    }));
                                    // handleStatusClick(idx)
                                }}

                                style={{ backgroundColor: 'rgb(22, 96, 200)' }}
                            >
                                Save
                            </button>
                            <button
                                className="text-xs bg-gray-200 text-gray-700 px-3 py-1.5 rounded-md hover:bg-gray-300 transition-colors"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    setShowOptionModal(null);
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default AutomationStatusDropdown;
